import { gql } from "@apollo/client";

export const GET_COORDINATES = gql`
	query Coordinates {
		coordinates {
			id
			trackId
			lat
			lan
			name
		}
	}
`;

export const GET_VANS = gql`
	query GetVans {
		cars {
			id
			trackId
			user {
				id
				role
				name
				email
			}
			model
			number
		}
	}
`;

export const UPDATE_VAN = gql`
	mutation UpdateVan($input: UpdateCarInput!) {
		updateCar(input: $input) {
			id
		}
	}
`;

export const CREATE_VAN = gql`
	mutation CreateVan($input: CreateCarInput!) {
		createCar(input: $input) {
			id
		}
	}
`;

export const DELETE_VAN = gql`
	mutation DeleteVan($id: String!) {
		deleteCar(id: $id)
	}
`;
